import { axiosTemplate } from './axiosTemplate'
export const  request =  axiosTemplate(process.env.VUE_APP_BASE_API)
export const  weChatrequest =  axiosTemplate("/ty-iot-manage")
export const  noBaseRequest =  axiosTemplate()

